import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Sprite from '~components/Sprite'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/dist/style.css'
import { getNextWorkingDay } from '~helpers/content'

class DatePicker extends Component {
  constructor (props) {
    super(props)

    this.state = {
      open: false
    }

    this.datePickerRef = React.createRef()
    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  getSelectedDay () {
    const date = this.props.value
    return date && date.toLocaleDateString()
  }

  componentDidMount () {
    document.addEventListener('click', this.handleClickOutside)
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
  }

  toggle (e) {
    const show = this.state.open

    this.setState((state) => {
      return { open: !show }
    })
  }

  show (show) {
    this.setState((state) => {
      return { open: show }
    })
  }

  handleClickOutside (e) {
    if (this.datePickerRef && !this.datePickerRef.current.contains(e.target)) {
      this.show(false)
    }
  }

  handleOnChange () {
    this.show(false)
    this.props.onChange && this.props.onChange(...arguments)
  }

  getNextNDays (days = 30) {
    const date = new Date()
    date.setDate(date.getDate() + days)
    return date.toISOString().split('T')[0]
  }

  render () {
    return (
      <div
        className={classNames('relative', this.props.className)}
        ref={this.datePickerRef}
      >
        <span
          className="relative flex items-center cursor-pointer"
          onClick={(e) => this.toggle(e)}
        >
          <span className="flex-shrink-0 w-6 h-6 mr-6" aria-hidden="true">
            <Sprite name="calendar" />
          </span>

          {this.props.value && (
            <span className="mr-4">
              {this.getSelectedDay()}
            </span>
          )}

          <button
            type="button"
            className="flex-shrink-0 underline hover:no-underline focus:no-underline"
          >
            edit
          </button>
        </span>

        {this.state.open && (
          <DayPicker
            onDayClick={this.handleOnChange}
            selectedDays={this.props.value}
            disabledDays={[
              { before: new Date(getNextWorkingDay(5)) },
              { after: new Date(this.getNextNDays(30)) },
              { daysOfWeek: [0, 6] }
            ]}
            className="absolute left-0 z-20 w-auto mt-4 bg-white top-full"
          />
        )}
      </div>
    )
  }
}

DatePicker.propTypes = {
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func
}

export default DatePicker
